import React from 'react';
import { IconProps } from '../IconProps';
const SvgCircleInfo = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M8 1.6A6.407 6.407 0 001.6 8c0 3.529 2.871 6.4 6.4 6.4 3.529 0 6.4-2.871 6.4-6.4 0-3.529-2.871-6.4-6.4-6.4zm.8 9.6a.8.8 0 11-1.6 0V7.6a.8.8 0 111.6 0v3.6zM8 6c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1z"
      fill="#0D0300"
    />
  </svg>
);
export default SvgCircleInfo;
